import { useHistory } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { ActiveItemTrending } from "./ActiveItemTrending";
import { AmountInCustomerCurrency } from "./AmountInCustomerCurrency";
import HomePageCard from "./HomePageCard";

type DefaultProps = {
  title: string | React.ReactNode;
  cloudCostsAtRisk: number;
  dataIcon: "trending up" | "trending down" | "warning" | "suggestion";
  trend: number | string;
  trendColor: string;
  trendDate?: string;
  value: number;
  buttonLink?: string;
  riskLabel?: string;
  riskIsNumber?: boolean;
  dontConvert?: boolean;
};

const ActiveItemsCard = ({
  title,
  value,
  cloudCostsAtRisk,
  dataIcon,
  trend,
  trendColor,
  trendDate,
  buttonLink,
  riskLabel = "Cloud costs at risk",
  riskIsNumber = false,
  dontConvert = false,
}: DefaultProps) => {
  const history = useHistory();

  return (
    <HomePageCard title={title}>
      <Stack direction="column" spacing={2} sx={{ p: 3, height: 161 }} justifyContent="space-between">
        <Stack direction="row" alignItems="center">
          <Typography sx={{ fontSize: 44, fontWeight: 500 }}>{value}</Typography>
          <ActiveItemTrending trend={trend} trendColor={trendColor} trendDate={trendDate} dataIcon={dataIcon} />
        </Stack>
        {cloudCostsAtRisk > 0 && (
          <Stack direction="row" alignItems="center">
            <Typography variant="caption" color="text.secondary">
              {riskLabel}:
            </Typography>
            <Typography variant="h3" color="text.primary" sx={{ ml: 1 }}>
              {riskIsNumber ? (
                cloudCostsAtRisk
              ) : (
                <AmountInCustomerCurrency amount={cloudCostsAtRisk} dontConvert={dontConvert} />
              )}
            </Typography>
          </Stack>
        )}
        <Button
          variant="outlined"
          size="small"
          sx={{ alignSelf: "flex-start" }}
          data-cy="anomalies-btn"
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            if (buttonLink) {
              history.push(buttonLink);
            }
          }}
        >
          Review and take action
        </Button>
      </Stack>
    </HomePageCard>
  );
};

export default ActiveItemsCard;
